const motionComponentSymbol = Symbol.for("motionComponentSymbol");
export { motionComponentSymbol };